import React, {Component, Fragment} from "react";
import {withRouter} from "react-router-dom";
import "./Register.css";
import {Col, Input, Row} from "reactstrap";
import DropdownComponent from "../../../components/DropdownComponent";
import S3DocumentUploadComponent from "../../../components/S3DocumentUploadComponent";
import RegistrationService from "../../../services/Registration/RegistrationService";
import RegistrationDocumentsService from "../../../services/Registration/RegistrationDocumentService";
import FileUtil from "../../../domain/Util/FileUtil";
import ToastHelper from "../../../utils/ToastHelper";
import UtilityCountryService from "../../../services/Util/UtilityCountryService";
import UtilityProvinceService from "../../../services/Util/UtilityProvinceService";
import RegistrationCreationRequest from "../../../domain/Registration/RegistrationCreationRequest";
import SFXButtonComponent from "../../../components/SFXButtonComponent";
import DatePickerComponent from "../../../components/DatePickerComponent";
import * as QueryStringUtils from "../../../utils/QueryStringUtil";

const GENDERS = [
    {id: 1, name: "Male"},
    {id: 2, name: "Female"}
];

const ID_TYPES = [
    {id: 1, name: "SA ID"},
    {id: 2, name: "Asylum Paper"},
    {id: 3, name: "Foreign Passport"},
    {id: 4, name: "Foreign ID"}
];

const PERSONAL_DETAILS_CONFIG = ["firstName", "lastName", "gender", "DOB", "phoneNumber"];
const ID_DETAILS_CONFIG = ["idType", "idNumber", "idExpiryDate", "country"];
const ID_DETAILS_SA_CONFIG = ["idType", "idNumber"];
const ADDRESS_DETAILS_CONFIG = ["streetNumber", "streetName", "town", "city", "province", "postalCode"];

const BUTTON_HEADERS = {
    "Identity": {"buttonHeader": "Photo of your Identity Document", "buttonText": "Document"},
    "Picture": {"buttonHeader": "Photo of yourself holding your Identity Document", "buttonText": "Selfie"}
};

const PERSONAL_DETAILS = "personal details";
const ADDRESS_DETAILS = "address details";
const ID_DETAILS = "nationality details";
const ID_DETAILS_SA = "nationality details_sa";
const DOCUMENT_DETAILS = "document details";
const REGISTRATION_SUMMARY = "registration summary";

const SA_ID = "SA ID";
const FOREIGN_ID = "Foreign ID";

class Register extends Component {

    constructor(props) {
        super(props);

        this.referralCode = QueryStringUtils.getQueryStringValue("referral-code");

        this.state = {
            countryOptions: [],
            provinceOptions: [],
            currentTab: PERSONAL_DETAILS,
            firstName: "",
            lastName: "",
            gender: {"id": 0, "name": ""},
            DOB: '',
            showDate: false,
            phoneNumber: "",

            idType: {"id": 0, "name": ""},
            idNumber: "",
            idExpiryDate: '',
            country: {"id": "", "name": ""},

            streetNumber: "",
            streetName: "",
            town: "",
            city: "",
            province: {"id": 0, "name": ""},
            postalCode: "",

            touchedFields: {},
            inValidFields: {},
            validFields: {},

            requiredDocuments: [],
            selectedDocuments: [],
            uploadedDocuments: {},

            submitButtonClicked: false,
            referralCode: this.referralCode
        };

        this.schema = RegistrationCreationRequest.retrieveNewRegistrationValidationConfig();

        this.handleChange = this.handleChange.bind(this);
        this.dropdownChange = this.dropdownChange.bind(this);
        this.hasBeenTouched = this.hasBeenTouched.bind(this);
        this.doneSelectingDocument = this.doneSelectingDocument.bind(this);
        this.doneUploadingDocument = this.doneUploadingDocument.bind(this);
        this.showNextDetailsPage = this.showNextDetailsPage.bind(this);
        this.goBack = this.goBack.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.createNewRegistration = this.createNewRegistration.bind(this);
        this.renderContent = this.renderContent.bind(this);
        this.renderPersonalDetails = this.renderPersonalDetails.bind(this);
        this.renderNationalityDetails = this.renderNationalityDetails.bind(this);
        this.renderAddressDetails = this.renderAddressDetails.bind(this);
        this.renderDocumentDetails = this.renderDocumentDetails.bind(this);
        this.renderButton = this.renderButton.bind(this);
        this.renderInput = this.renderInput.bind(this);
        this.renderDropdown = this.renderDropdown.bind(this);
    }

    componentDidMount() {

        let promiseArr = [];

        promiseArr.push(UtilityCountryService.retrieveCountryList());
        promiseArr.push(UtilityProvinceService.retrieveProvinceList());
        promiseArr.push(RegistrationDocumentsService.retrieveRegistrationRequiredDocuments());

        Promise.all(promiseArr).then(response => {

            let countryList = response[0];
            let provinceList = response[1];
            let requiredDocumentsList = response[2];

            this.setState({
                countryOptions: countryList,
                provinceOptions: provinceList,
                requiredDocuments: requiredDocumentsList
            })
        })
    }

    showNextDetailsPage(nextPage) {
        this.setState({
            currentTab: nextPage
        })
    }

    goBack() {

        if (this.state.currentTab === PERSONAL_DETAILS) {
            this.props.history.replace("/home");
        } else if (this.state.currentTab === ID_DETAILS) {
            this.setState({
                currentTab: PERSONAL_DETAILS
            })
        } else if (this.state.currentTab === ID_DETAILS_SA) {
            this.setState({
                currentTab: PERSONAL_DETAILS
            })
        } else if (this.state.currentTab === ADDRESS_DETAILS) {
            let currentTab = ID_DETAILS;
            if(this.state.idType.name === SA_ID
                || this.state.idType.name === FOREIGN_ID
            ){
                currentTab = ID_DETAILS_SA;
            }
            this.setState({
                currentTab: currentTab
            })
        } else if (this.state.currentTab === DOCUMENT_DETAILS) {
            this.setState({
                currentTab: ADDRESS_DETAILS
            })
        } else if (this.state.currentTab === REGISTRATION_SUMMARY) {
            this.setState({
                currentTab: DOCUMENT_DETAILS
            })
        }
    }

    handleChange = (event, field) => {

        this.setState({
            [event.target.id]: event.target.value
        }, () => this.validateInputField(field));
    };

    handleDateChange(field, value) {
        this.setState({
            [field]: value
        }, () => this.validateInputField(field))
    }

    dropdownChange = (event, field) => {

        let newEvent;
        if (event === null) {
            if (field === 'country') {
                newEvent = {"id": "", "name": ""}
            } else {
                newEvent = {"id": 0, "name": ""}
            }
        } else {
            newEvent = {...event};
        }

        let extra = {};
        if (field === "idType") {
            if (newEvent.name === SA_ID
                || newEvent.name === FOREIGN_ID
            )
                extra.currentTab = ID_DETAILS_SA;
            else
                extra.currentTab = ID_DETAILS;
        }

        this.setState({
            ...extra,
            [field]: {
                id: newEvent.id,
                name: newEvent.name
            }
        }, () => this.validateInputField(field));
    };

    handleUpload() {

        let self = this;

        for (let i = 0; i < this.state.requiredDocuments.length; i++) {

            let documentType = this.state.requiredDocuments[i].documentType;

            let file = this.state.selectedDocuments[documentType];

            let fileType = FileUtil.getExtensionOfFile(file.fileUpload.name);
            let mimeType = FileUtil.getMimeType(fileType);

            let s3Document = {
                "file-type": fileType,
                "registration-document-type": documentType
            };
            RegistrationDocumentsService.retrievePresignedUrl(s3Document).then(response => {
                if (response.presignedUrl === undefined) {
                    ToastHelper.error("Failed to retrieve upload url.");
                    return;
                }

                const xhr = new XMLHttpRequest();
                xhr.open('PUT', response.presignedUrl);
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            let uploadedDocument = {...self.state.uploadedDocuments};
                            uploadedDocument[documentType] = response;
                            self.setState({
                                uploadedDocuments: uploadedDocument
                            }, () => self.doneUploadingDocument());
                        } else {
                            ToastHelper.error("Error while uploading image.");
                        }
                    }
                };
                xhr.overrideMimeType(mimeType);
                xhr.setRequestHeader('Content-Type', mimeType);
                xhr.send(file.fileUpload);
            });
        }
    }

    doneUploadingDocument() {

        let allUploaded = true;
        this.state.requiredDocuments.forEach(requiredDocument => {
            if (this.state.uploadedDocuments[requiredDocument.documentType] === undefined) {
                allUploaded = false;
            }
        });
        if (allUploaded) {
            this.createNewRegistration();
        }
    }

    doneSelectingDocument() {

        let allSelected = true;
        this.state.requiredDocuments.forEach(requiredDocument => {
            if (this.state.selectedDocuments[requiredDocument.documentType] === undefined) {
                allSelected = false;
            }
        });

        return allSelected;
    }

    createNewRegistration() {

        if (this.submitting) {
            return;
        }

        this.submitting = true;

        let documents = [];

        for (let i = 0; i < this.state.requiredDocuments.length; i++) {
            let documentType = this.state.requiredDocuments[i].documentType;
            documents.push({
                "meta-data-id": this.state.uploadedDocuments[documentType].id,
                "document-type": documentType
            })
        }

        let registrationCreationRequest = {
            "city": this.state.city,
            "dob": this.state.DOB,
            "documents": documents,
            "firstName": this.state.firstName,
            "gender": this.state.gender.name,
            "idType": this.state.idType.name,
            "idNumber": this.state.idNumber,
            "lastName": this.state.lastName,
            "msisdn": this.state.phoneNumber,
            "postalCode": this.state.postalCode,
            "streetNumber": this.state.streetNumber,
            "streetName": this.state.streetName,
            "town": this.state.town,
            "province": this.state.province.name
        };

        if (registrationCreationRequest.idType === SA_ID
            || registrationCreationRequest.idType === FOREIGN_ID
        ) {
            registrationCreationRequest["idExpiryDate"] = "9999-12-31";
            registrationCreationRequest["nationality"] = this.state.country.id;
        } else {
            registrationCreationRequest["idExpiryDate"] = this.state.idExpiryDate;
            registrationCreationRequest["nationality"] = this.state.country.id;
        }

        RegistrationService.createRegistration(registrationCreationRequest, this.state.referralCode).then(response => {
            if (response.registrationId) {
                this.props.history.replace("/home");
                ToastHelper.success("You have successfully been registered");
            } else {
                this.submitting = false;
                this.setState({
                    submitButtonClicked: false
                });
                ToastHelper.formatError(response)
            }
        })
    }

    invalidateIdNumber() {
        let previousValidState = {...this.state.validFields};
        delete previousValidState["idNumber"];
        this.setState({
            idNumber: "",
            validFields: previousValidState
        });
    }

    validateInputField(field) {
        let self = this;
        let previousInvalidValidations = {...this.state.inValidFields};
        delete previousInvalidValidations[field];
        let previousValidValidations = {...this.state.validFields};
        previousValidValidations[field] = true;

        this.setState({
            inValidFields: previousInvalidValidations,
            validFields: previousValidValidations
        }, () => {

            let fieldValue = this.state[field].id === undefined ? this.state[field] : this.state[field].name;

            if (field === "idType" && fieldValue === SA_ID) {
                delete this.schema["idNumber"];
                this.schema["idNumber"] = RegistrationCreationRequest.retrieveSAIDValidationConfig(this.state.gender.name, this.state.DOB)
                this.invalidateIdNumber();
            } else if (field === "idType" && fieldValue !== SA_ID) {
                delete this.schema["idNumber"];
                this.schema["idNumber"] = RegistrationCreationRequest.retrieveNonSAIDValidationConfig();
                this.invalidateIdNumber();
            } else if (field === "country" && this.state["idType"].name !== SA_ID) {
                this.schema["country"] = RegistrationCreationRequest.retrieveCountryValidationConfig();
            }

            if (this.schema[field] !== undefined) {
                this.schema[field].validate({[field]: fieldValue}).catch(function (err) {

                    let previousInvalidValidations = {...self.state.inValidFields};
                    previousInvalidValidations[field] = err.message;
                    let previousValidValidations = {...self.state.validFields};
                    delete previousValidValidations[field];
                    self.setState({
                        inValidFields: previousInvalidValidations,
                        validFields: previousValidValidations
                    });
                })
            }
        })
    }

    hasBeenTouched(field) {

        let previousTouched = {...this.state.touchedFields};
        previousTouched[field] = true;
        this.setState({
                touchedFields: previousTouched
            }, () => this.validateInputField(field)
        )
    }

    isNextButtonValid(config) {
        let allFieldsComplete = true;

        config.forEach(field => {
            if (this.state.validFields[field] === undefined) {
                allFieldsComplete = false;
            }
        });

        return allFieldsComplete;
    }

    isFinishButtonValid() {

        return !this.state.submitButtonClicked && this.doneSelectingDocument();

    }

    render() {
        return <Fragment>

            {this.props.isMobile ? this.renderContent("mobile") : this.renderContent("browser")}

        </Fragment>

    }

    renderContent(className) {

        return <Fragment>

            <div className={className + "_background_default_register"}>
                {this.props.isMobile ? <div className={className + "_header"}>
                        <div className={"fa fa-arrow-left " + className + "_register_back_btn"} onClick={this.goBack}/>
                        <div className={className + "_header_text"}>SIGN UP</div>
                    </div>
                    :
                    <Fragment>

                    </Fragment>
                }
                <div className={className + " logo_register"}>
                    <Col align={"center"}>
                        {this.props.isMobile ? <img src={"./assets/RiaLogoVariations/ria_logo_horizontal_colour.png"} alt="" width="auto" height="50px"/> :
                            <div style={{marginTop: "10px"}}>
                                <h1 className={"browser_register_main_heading"}>Sign Up</h1>
                            </div>
                        }
                        <br />
                        <br />
                    </Col>
                </div>

                <div className={className + "_register_detail_fields"}>
                    {this.state.currentTab === PERSONAL_DETAILS && this.renderPersonalDetails(className)}
                    {(this.state.currentTab === ID_DETAILS || this.state.currentTab === ID_DETAILS_SA) && this.renderNationalityDetails(className)}
                    {this.state.currentTab === ADDRESS_DETAILS && this.renderAddressDetails(className)}
                    {this.state.currentTab === DOCUMENT_DETAILS && this.renderDocumentDetails(className)}
                </div>
            </div>

        </Fragment>

    }

    renderPersonalDetails(className) {

        return <Fragment>
            {!this.props.isMobile ? <Fragment><h2 className={"browser_register_sub_heading"}>Personal Details</h2>
                    <br/>
                </Fragment>
                :
                <Fragment>

                </Fragment>
            }
            {this.renderInput(className, "First Name", "firstName", "user")}
            {this.renderInput(className, "Last Name", "lastName", "user")}
            {this.renderDropdown(className, GENDERS, "gender", "Select Gender", "user")}
            {this.renderDatePicker(className, "Date of Birth", "DOB")}
            {this.renderInput(className, "Mobile Number", "phoneNumber", "phone")}

            {this.renderButton("NEXT", this.state.idType.name !== SA_ID ? ID_DETAILS : ID_DETAILS_SA, className, PERSONAL_DETAILS_CONFIG)}
            {this.renderBackButton("BACK", className)}

        </Fragment>

    }

    renderNationalityDetails(className) {
        return <Fragment>
            {!this.props.isMobile ? <Fragment><h2 className={"browser_register_sub_heading"}>Nationality Details</h2>
                    <br/>
                </Fragment>
                :
                <Fragment>

                </Fragment>
            }
            {this.state.currentTab === ID_DETAILS
                ? <Fragment>
                    {this.renderDropdown(className, ID_TYPES, "idType", "ID Type", "flag")}
                    {this.renderInput(className, "ID Number", "idNumber", "user")}
                    {this.renderDatePicker(className, "ID Expiry Date", "idExpiryDate")}
                    {this.renderDropdown(className, this.state.countryOptions, "country", "Nationality", "flag")}
                </Fragment>
                : <Fragment>
                    {this.renderDropdown(className, ID_TYPES, "idType", "ID Type", "flag")}
                    {this.renderInput(className, "ID Number", "idNumber", "user")}
                    {this.renderDropdown(className, this.state.countryOptions, "country", "Nationality", "flag")}
                </Fragment>
            }

            {this.renderButton("NEXT", ADDRESS_DETAILS, className, this.state.currentTab === ID_DETAILS ? ID_DETAILS_CONFIG : ID_DETAILS_SA_CONFIG)}
            {this.renderBackButton("BACK", className)}
        </Fragment>

    }

    renderAddressDetails(className) {

        return <Fragment>
            {!this.props.isMobile ? <Fragment><h2 className={"browser_register_sub_heading"}>Address Details</h2>
                    <br/>
                </Fragment>
                :
                <Fragment>

                </Fragment>
            }
            {this.renderInput(className, "Street Number", "streetNumber", "map-marker")}
            {this.renderInput(className, "Street Name", "streetName", "map-marker")}
            {this.renderInput(className, "Town", "town", "map-marker")}
            {this.renderInput(className, "City", "city", "map-marker")}
            {this.renderDropdown(className, this.state.provinceOptions, "province", "Province", "map-marker")}
            {this.renderInput(className, "Postal Code", "postalCode", "map-marker")}

            {this.renderButton("NEXT", DOCUMENT_DETAILS, className, ADDRESS_DETAILS_CONFIG)}
            {this.renderBackButton("BACK", className)}
        </Fragment>

    }

    renderDocumentDetails(className) {
        return <Fragment>
            {!this.props.isMobile ? <Fragment><h2 className={"browser_register_sub_heading"}>Documents</h2>
                    <br/>
                </Fragment>
                :
                <Fragment>

                </Fragment>
            }
            {this.state.requiredDocuments.map((requiredDocument, index) => {
                return <S3DocumentUploadComponent
                    key={index}
                    documentType={requiredDocument.documentType}
                    showButton={false}
                    buttonConfig={BUTTON_HEADERS[requiredDocument.documentType]}
                    className={className}
                    fileSelected={this.state.selectedDocuments[requiredDocument.documentType] !== undefined}
                    onFileSelected={file => {
                        if (file !== null) {
                            let docArr = {...this.state.selectedDocuments};
                            docArr[requiredDocument.documentType] = file;
                            this.setState({
                                selectedDocuments: docArr
                            })
                        }

                    }}
                />
            })}

            {this.renderFinishButton("FINISH", className)}
            {this.renderBackButton("BACK", className)}
        </Fragment>

    }

    renderButton(buttonText, detailsPage, className, config) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_register_button"}
                onClick={() => this.showNextDetailsPage(detailsPage)}
                disabled={!this.isNextButtonValid(config)}
            >{buttonText}
            </SFXButtonComponent>
        </div>
    }

    renderBackButton(buttonText, className) {

        return <Fragment>
            {!this.props.isMobile ? <div className={className + "_register_button_div"}>
                    <SFXButtonComponent
                        className={className + "_register_back_button"}
                        onClick={() => this.goBack()}
                    >{buttonText}
                    </SFXButtonComponent>
                </div>
                :
                <Fragment></Fragment>
            }
        </Fragment>
    }

    renderFinishButton(buttonText, className) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_register_button"}
                onClick={() => this.setState({submitButtonClicked: true}, this.handleUpload)}
                disabled={!this.isFinishButtonValid()}
            >{buttonText}
            </SFXButtonComponent>
        </div>

    }

    renderInput(className, text, field, icon) {

        return <Row className={className + "_input_row_register"}>
            <div className={"fa fa-" + icon + " " + className + "_user_icon_register"}/>
            <div className={className + "_input_div_register"}>
                <Input className={className + "_input_register"} value={this.state[field]} placeholder={text}
                       id={field}
                       onChange={(event) => this.handleChange(event, field)}
                       onBlur={() => this.hasBeenTouched(field)}
                />
                {this.state.touchedFields[field] && this.state.inValidFields[field] && this.renderErrorMessage(className, field)}
            </div>
        </Row>

    }

    renderDatePicker(className, text, field) {

        let dateType = "";
        if (field === "DOB") {
            dateType = "PAST";
        } else if (field === "idExpiryDate") {
            dateType = "ID_EXPIRY";
        }

        return <Row className={className + "_input_row_register"}>
            <div className={"fa fa-calendar " + className + "_user_icon_register"}/>
            <div className={className + "_input_div_register"}>
                <DatePickerComponent
                    inputStyle={className + "_input_register"}
                    onChange={(value) => {
                        this.handleDateChange(field, value)
                    }}
                    isMobile={this.props.isMobile}
                    firstTouch={() => this.hasBeenTouched(field)}
                    value={this.state[field]}
                    placeholder={text}
                    type={dateType}
                />
                {this.state.touchedFields[field] && this.state.inValidFields[field] && this.renderErrorMessage(className, field)}
            </div>
        </Row>

    }

    renderDropdown(className, dropdownOptions, field, text, icon) {

        return <Row className={className + "_input_row_register"}>
            <div className={"fa fa-" + icon + " " + className + "_user_icon_register"}/>
            <div className={className + "_input_div_register"}>
                <DropdownComponent
                    className={className + "_input_register"}
                    value={this.state[field].id || ""}
                    options={dropdownOptions}
                    placeholder={text}
                    onChange={(selectedOption) => {
                        this.dropdownChange(selectedOption, field)
                    }}
                    onBlur={() => this.hasBeenTouched(field)}
                />
                {this.state.touchedFields[field] && this.state.inValidFields[field] && this.renderErrorMessage(className, field)}
            </div>
        </Row>
    }

    renderErrorMessage(className, field) {
        return <h6 className={className + "_error_message_register"}>
            {this.state.inValidFields[field]}
        </h6>;
    }
}

export default withRouter(Register);